import types from '../../mutation-types';

export const actions = {
  setCount: ({ commit }, count) => {
    commit(types.SET_QUEUE_COUNT, count);
  },
};
